import { TableCell, TableRow } from "@capacit-com/lara-law-shared-ui";
import { Skeleton } from "@capacit-com/lara-law-shared-ui";

export const OrganizationUsersSkeletonRow = () => {
  return (
    <TableRow>
      <TableCell className="w-[37%]">
        <div className="min-h-12 flex items-center">
          <Skeleton className="size-7 rounded-full mr-2" />
          <Skeleton className="h-4 w-[50%]" />
        </div>
      </TableCell>
      <TableCell className="w-[37%]">
        <div className="min-h-12 flex items-center">
          <Skeleton className="h-4 w-[40%]" />
        </div>
      </TableCell>
      <TableCell className="w-[10%]">
        <div className="min-h-12 flex items-center">
          <Skeleton className="h-4 w-[35%]" />
        </div>
      </TableCell>
      <TableCell className="w-[20%]">
        <div className="min-h-12 flex items-center">
          <Skeleton className="size-9" />
        </div>
      </TableCell>
    </TableRow>
  );
};
